import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import TableConversations from "../Table/TableConversations";
import TableUsers from "../Table/TableUsers";
import {
    conversationsWithFlag,
    usersWithFlag
} from "../../actions";
import {connect} from "react-redux";
import {withRouter} from "react-router";

function TabPanel(props) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    {children}
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}));

function ManageNetworking(props) {
    const conferenceUUID = props.conference.data.uuid

    const classes = useStyles();
    const [value, setValue] = useState(0);
    const [users, setUsers] = useState(props.users);
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <div className={classes.root}>
            <AppBar position="static">
                <Tabs value={value} onChange={handleChange} aria-label="manage networking tabs">
                    <Tab label="Conversations" {...a11yProps(0)} />
                    <Tab label="Users" {...a11yProps(1)} />
                </Tabs>
            </AppBar>
            <TabPanel value={value} index={0}>
                <TableConversations/>
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TableUsers/>
            </TabPanel>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        conference: state.conferences
    };
}


const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ManageNetworking));
